import React, { useEffect, useState } from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import CSOverview from "aldoo-ra/Admin/CustomerSupport/cs-overview"
import CSTickets from "aldoo-ra/Admin/CustomerSupport/cs-tickets"
import CSAgents from "aldoo-ra/Admin/CustomerSupport/cs-agents"
import CSForward from "aldoo-ra/Admin/CustomerSupport/cs-forward"
import CSSettings from "aldoo-ra/Admin/CustomerSupport/cs-settings"
import Value from "aldoo-ra/Value" // Added Value import
import useCSStatistics from "aldoo-ra/Admin/CustomerSupport/useCSStatistics"
import Typography from "aldoo-ra/Typography"

const CustomerSupportHome = () => {
  // Use the statistics hook to automatically fetch and refresh CS statistics
  const { statistics } = useCSStatistics()

  // Added direct Value hook to monitor changes in cs-statistics
  const [statsValue, setStatsValue] = Value("cs-statistics", null)

  // State to force re-renders when statistics change
  const [pendingCount, setPendingCount] = useState(0)

  // Update pendingCount when statsValue changes - watch specific values
  // Show badge for open tickets needing attention
  useEffect(() => {
    const openTickets = statsValue?.openTickets ?? 0
    setPendingCount(openTickets)
  }, [statsValue?.openTickets])

  // Custom tab resolver function
  const customTabResolver = (defaultTab, context, pathname) => {
    // Check if we're on a ticket detail page
    if (pathname.includes("/admin/customer-support/tickets/")) {
      return "tickets" // Always return 'tickets' for ticket detail pages
    }
    // Return undefined to use the default tab
    return undefined
  }

  return (
    <SidePanelLayout
      menuName="AdminCustomerSupportMenu"
      tabs={{
        overview: CSOverview,
        tickets: CSTickets,
        agents: CSAgents,
        forward: CSForward,
        settings: CSSettings,
      }}
      tabResolver={customTabResolver}
      onMenuItemRender={(item) => {
        // Only show the badge for the tickets menu item
        if (item.name !== "CustomerSupportTickets") return null
        // Only show badge if pending count is greater than 0
        if (pendingCount <= 0) return null
        // Show notification badge with pendingReply count
        return (
          <div className="min-w-[20px] h-5 flex items-center justify-center rounded-full bg-admin_error px-1.5">
            <Typography
              variant="admin_txt2"
              className="text-white"
            >
              {pendingCount > 99 ? "99+" : pendingCount}
            </Typography>
          </div>
        )
      }}
    />
  )
}

export default CustomerSupportHome
